<div class="d-flex quote-page-main flex-column">
	<app-quote-focus-logo></app-quote-focus-logo>
	<div class="d-flex mx-auto display-6">Thank you for your order!</div>
	<div class="d-flex mx-auto item-med">An copy of your order has been sent to your email ({{ quoteService.quoteAcceptance.value.emailAddress }}).</div>
	<div class="d-flex flex-column" *ngIf="quoteService.quote.value.Opportunity.RecordTypeId === '01216000001BMocAAG'">
		<div class="mx-auto item-med">Please provide your payment information below.</div>
		<div class="mx-auto item-med">This <i>Payment Profile</i> will be used for all on-going transactions with Focus.</div>
		<app-payment-profile-setup [source]="'quote'" [venueName]="quoteService.quote.value.Opportunity.Account.Name"></app-payment-profile-setup>
	</div>
</div>
😚
